<script setup>
import { computed, ref } from "vue";
import TopJumbotron from "@/components/TopJumbotron.vue";
import TracksListItem from "@/components/TracksListItem.vue";
import { useTrackStore } from "@/stores/TrackStore.js";
import { storeToRefs } from "pinia";

const trackStore = useTrackStore();
trackStore.fill();
const { filteredTracks, filter, loading } = storeToRefs(trackStore);

const sortKey = ref("genres");

const sortedTracks = computed(() => {
  const tracksCopy = [...filteredTracks.value];
  return tracksCopy.sort((a, b) => {
    let sortKeyA, sortKeyB;
    if (sortKey.value == "genres") {
      sortKeyA = a.genreNames;
      sortKeyB = b.genreNames;
    } else if (sortKey.value == "artist") {
      sortKeyA = a.artistName + a.title;
      sortKeyB = b.artistName + b.title;
    }
    return sortKeyA.localeCompare(sortKeyB);
  });
});

const sortBy = function sortBy(newSortKey) {
  sortKey.value = newSortKey;
};
</script>

<template>
  <div class="col tracks-list">
    <TopJumbotron v-if="!filter" />
    <div v-if="filter" class="card text-white bg-dark rounded-3 shadow-sm">
      <div class="card-header py-3">
        <h4 class="my-0 fw-normal">
          {{ filter.title }}: <em>{{ filter.description }}</em>
        </h4>
      </div>
      <div class="card-body">
        <div class="table-responsive mt-4">
          <div v-if="loading" class="text-center m-5">
            <div class="spinner-grow" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <table
            v-else
            class="table table-dark table-sm small table-hover align-middle"
          >
            <thead>
              <th @click="sortBy('artist')" role="button">
                <em>Artist</em> / Title
                <fa v-if="sortKey.value == 'artist'" icon="sort-down" />
                <fa v-else icon="sort" class="text-muted" />
              </th>
              <th @click="sortBy('genres')" role="button">
                Genres
                <fa v-if="sortKey.value == 'genres'" icon="sort-down" />
                <fa v-else icon="sort" class="text-muted" />
              </th>
              <th class="text-center">Vocal</th>
              <th class="text-center">BPM</th>
              <th class="text-center">Time</th>
              <th class="text-center">Favorite</th>
            </thead>
            <tbody style="cursor: pointer">
              <tracks-list-item
                v-for="track in sortedTracks"
                :key="track.id"
                :track="track"
              ></tracks-list-item>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
